import { render, staticRenderFns } from "./BenefitModal.vue?vue&type=template&id=dfcb5a76&"
import script from "./BenefitModal.vue?vue&type=script&lang=js&"
export * from "./BenefitModal.vue?vue&type=script&lang=js&"
import style0 from "./BenefitModal.vue?vue&type=style&index=0&id=dfcb5a76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports